import { MyCompanyPanelWebComponent } from './component/MyCompanyPanelWebComponent';
import { WEB_COMPONENT_MY_COMPANY_PANEL } from '../../../webcomponents.constants';

export { MyCompanyPanelWebComponent };

window.customElements.define(WEB_COMPONENT_MY_COMPANY_PANEL, MyCompanyPanelWebComponent);
